import { usePanels } from '../panels/usePanels';
import { aiAgentCenterPanelType } from '../dashboard/aiAgents/aiAgentCenterPanelType';

export const useIsAgentsPanelOpen = () => {
  const { isPanelOpen } = usePanels();
  return isPanelOpen(aiAgentCenterPanelType);
};
